import z from 'zod';

export enum JournalSessionType {
  MANUAL = 'manual',
  REPLAY = 'replay',
}

export const journalSessionTypeSchema = z.enum(JournalSessionType);
